import type { PictureTalkSceneDetail, PictureTalkSceneItem } from '@/modules/learning/api/pictureTalk';
import {
  buildItemsTaList,
  displayItemDescription,
  displayItemEnglishTitle,
  displayItemTitle,
  displaySceneSummaryEn,
  displaySceneSummaryTa,
  displaySceneTheme,
  displaySceneTitle,
  displaySceneTitleEnglish,
} from '@/modules/learning/api/pictureTalk';

function line(key: string, value: string): string {
  return `${key}: ${value.replace(/\r?\n/g, ' ')}`;
}

/** Multiline EVENT: START payload — SCENE_* plus TOPIC_* aliases for legacy prompts. */
export function buildPictureTalkStartEvent(scene: PictureTalkSceneDetail): string {
  const lines: string[] = ['EVENT: START'];
  lines.push(line('SCENE_ID', scene.scene_id));
  lines.push(line('SCENE_TITLE_TA', displaySceneTitle(scene)));
  const titleEn = displaySceneTitleEnglish(scene);
  if (titleEn) lines.push(line('SCENE_TITLE_EN', titleEn));
  const sumTa = displaySceneSummaryTa(scene);
  if (sumTa) lines.push(line('SCENE_SUMMARY_TA', sumTa));
  const sumEn = displaySceneSummaryEn(scene);
  if (sumEn) lines.push(line('SCENE_SUMMARY_EN', sumEn));
  const theme = displaySceneTheme(scene);
  if (theme) lines.push(line('SCENE_THEME', theme));
  if (scene.items.length > 0) {
    lines.push(line('ITEMS_TA', buildItemsTaList(scene)));
  }
  lines.push(line('TOPIC_ID', scene.scene_id));
  lines.push(line('TOPIC_TA', displaySceneTitle(scene)));
  return lines.join('\n');
}

/** Multiline OBJECT_CLICKED — newest click only; aliases for legacy prompts. */
export function buildPictureTalkObjectClickedEvent(
  scene: PictureTalkSceneDetail,
  item: PictureTalkSceneItem
): string {
  const itemTa = displayItemTitle(item);
  const itemEn = displayItemEnglishTitle(item);
  const desc = displayItemDescription(item) || itemTa;
  const itemsTa = buildItemsTaList(scene);
  return [
    'EVENT: OBJECT_CLICKED',
    line('SCENE_ID', scene.scene_id),
    line('ITEM_ID', item.id),
    line('ITEM_TA', itemTa),
    line('ITEM_EN', itemEn),
    line('ITEM_DESC_TA', desc),
    line('ITEMS_TA', itemsTa),
    line('TOPIC_ID', scene.scene_id),
    line('TOPIC_TA', displaySceneTitle(scene)),
  ].join('\n');
}
